let dept_ry = {
  saveOrgMemberNet: {
    //新增部门成员信息
    url: '/scooper-core-rest/data/contacts/orgMemberManage/saveOrgMember',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      deptId: '',
      //	T	部门ID
      memCode: '',
      //	F	成员编号, 供第三方关联使用
      memName: '',
      //	T	成员姓名
      sex: '',
      //	T	性别: 1-男; 2-女
      memTel: '',
      //	T	成员号码
      memType: '',
      //	T	成员类型: 0-一般用户；1-视频话机用户；2-移动终端用户；
      memMobile: '',
      //	T	手机号码(memMobile和memTel2不能都为空)
      memTel2: '',
      //	T	号码二(memMobile和memTel2不能都为空)
      memFax: '',
      //	F	传真号码
      memEmail: '',
      //	F	电子邮箱
      dutyId: '',
      //	F	职务id
      deptName: '',
      isActive: 1,
      dutyName: '',
      //职务名称
      memLevel: 1,
      accId: '',
      //帐号id
      memMsgLevel: '',
      businessConfigs: '',
      //业务权限
      isOperAcc: true,
      mainTel: '',
      operMobileTel: '',
      mobileTel: '',
      viceTel: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: '' //保存成功的id

    }
  },
  createOnGis: {
    //同步新成员到gis
    url: '/common-gis-web/data/gispos/addPersion',
    method: 'POST',
    contentType: 'application/json;charset=utf-8',
    paramOnUrl: ['token'],
    requestParam: {
      token: '',
      name: '',
      // 成员名称
      propKey: '',
      // 成员id
      center: {
        latitude: 30.223853,
        longitude: 120.01802
      }
    },
    responseParam: {
      code: '',
      //返回结果状态码 0为成功
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {} //结果内容

    }
  },
  createRyAndAccount: {
    //一键创建
    url: '/scooper-app-manager/data/dev/saveApp',
    method: 'POST',
    requestParam: {
      token: '',
      deptId: '',
      // 部门id
      deptName: '',
      // 部门名称
      memName: '',
      //成员名	
      sex: 0,
      // 性别 0-女， 1：男
      memType: '',
      //成员类型，0-一般用户；1-视频话机用户；2-app用户；
      memTel: '',
      //成员号码
      memMobile: '',
      //电话号码
      accUsername: '',
      //用户名
      accPassword: '',
      //密码，加密，
      accShowname: '' //用户展示名称

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {} //结果内容

    }
  },
  updateOrgMemberNet: {
    //更新部门成员信息
    url: '/scooper-core-rest/data/contacts/orgMemberManage/updateOrgMember',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      deptId: '',
      //	T	部门ID
      memCode: '',
      //	F	成员编号, 供第三方关联使用
      memName: '',
      //	T	成员姓名
      sex: '',
      //	T	性别: 1-男; 2-女
      memTel: '',
      //	T	成员号码
      memType: '',
      //	T	成员类型: 0-一般用户；1-视频话机用户；2-移动终端用户；
      memMobile: '',
      //	T	手机号码(memMobile和memTel2不能都为空)
      memTel2: '',
      //	T	号码二(memMobile和memTel2不能都为空)
      memFax: '',
      //	F	传真号码
      memEmail: '',
      //	F	电子邮箱
      dutyId: '',
      //	F	职务id
      id: '' //成员id

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {} //结果内容

    }
  },
  deleteOrgMemberNet: {
    //删除部门成员信息
    url: '/scooper-core-rest/data/contacts/orgMemberManage/deleteOrgMember',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      ids: '' //	T	id 多个用“，”分隔

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {} //结果内容

    }
  },
  getOrgMemberDetailNet: {
    //查询部门成员详情信息
    url: '/scooper-core-rest/data/contacts/orgMemberManage/getOrgMemberDetail',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '' //	T	成员编号

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        id: '',
        //	T	
        deptId: '',
        //	T	部门ID
        memCode: '',
        //	T	成员编号, 供第三方关联使用
        memName: '',
        //	T	成员姓名
        sex: '',
        //	T	性别: 1-男; 2-女
        firstLetter: '',
        //	T	姓名拼音首字母
        memTel: '',
        //	T	成员号码
        memType: '',
        //	T	成员类型:0-一般用户；1-视频话机用户；2-移动终端用户；
        memMobile: '',
        //	T	手机号码
        memTel2: '',
        //	T	号码二
        memTel3: '',
        //	T	号码三
        memTel4: '',
        //	T	号码四
        memTel5: '',
        //	T	号码五
        memFax: '',
        //	T	传真号码
        memEmail: '',
        //	T	电子邮箱
        memPicture: '',
        //	T	图片
        memVideo: '',
        //	T	视频
        memGis: '',
        //	T	GI坐标
        orgCode: '',
        //	T	组织编码
        sortIndex: '',
        //T	排序号
        updateTime: '',
        //	T	更新时间
        deptExt: '',
        //	T	扩展字段
        isActive: '',
        //	T	是否激活
        modifyTime: '',
        //	T	记录修改时间
        memLevel: '',
        //	T	成员等级
        memQq: '',
        //	T	QQ号码
        deptName: '' //	T	部门名称

      } //结果内容

    }
  },
  queryOrgMemberNet: {
    //分页查询成员列表信息
    url: '/scooper-core-rest/data/contacts/orgMemberManage/queryOrgMember',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      currentPage: '',
      //	F	当前页码（默认1）
      pageSize: '',
      //	F	每页条数（默认30）
      deptId: '',
      //	F	所属部门ID
      modifyTimeStart: '',
      //	F	记录修改开始时间
      modifyTimeEnd: '',
      //	F	记录修改结束时间

      /**
       * 可以模糊匹配：
      1.成员名字 2.成员号码  3.号码二~五
      4.手机号码 5.传真号码
      */
      keyword: '',
      //	F	关键字
      ids: '' //	F	通过ids串查询列表（','分割）

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        pageNum: '',
        //	T	当前页
        pageSize: '',
        //	T	每页的数量
        size: '',
        //	T	当前页的数量
        startRow: '',
        //	T	当前页面第一个元素在数据库中的行号
        endRow: '',
        //	T	当前页面最后一个元素在数据库中的行号
        total: '',
        //	T	总记录数
        pages: '',
        //	T	总页数
        list: [{
          id: '',
          //	T	
          deptId: '',
          //	T	部门ID
          memCode: '',
          //	T	成员编号, 供第三方关联使用
          memName: '',
          //	T	成员姓名
          sex: '',
          //	T	性别: 1-男; 2-女
          firstLetter: '',
          //	T	姓名拼音首字母
          memTel: '',
          //	T	成员号码
          memType: '',
          //	T	成员类型:0-一般用户；1-视频话机用户；2-移动终端用户；
          memMobile: '',
          //	T	手机号码
          memTel2: '',
          //	T	号码二
          memTel3: '',
          //	T	号码三
          memTel4: '',
          //	T	号码四
          memTel5: '',
          //	T	号码五
          memFax: '',
          //	T	传真号码
          memEmail: '',
          //	T	电子邮箱
          memPicture: '',
          //	T	图片
          memVideo: '',
          //	T	视频
          memGis: '',
          //	T	GI坐标
          orgCode: '',
          //	T	组织编码
          sortIndex: '',
          //T	排序号
          updateTime: '',
          //	T	更新时间
          deptExt: '',
          //	T	扩展字段
          isActive: '',
          //	T	是否激活
          modifyTime: '',
          //	T	记录修改时间
          memLevel: '',
          //	T	成员等级
          memQq: '',
          //	T	QQ号码
          deptName: '' //	T	部门名称

        }],
        //部门成员列表, //	T	结果集
        modifyPwTime: '',
        //	T	密码修改时间
        firstPage: '',
        //	T	第一页
        perPage: '',
        //	T	前一页
        nextPage: '',
        //	T	下一页
        lastPage: '',
        //	T	最后一页
        isFirstPage: '',
        //	T	是否为第一页
        isLastPage: '',
        //	T	是否为最后一页
        hasPreviousPage: '',
        //	T	是否有前一页
        hasNextPage: '',
        //	T	是否有下一页
        navigatePage: '',
        //	T	导航页码数
        navigatePageNums: '' //	T	所有导航页号

      }
    }
  },
  listOrgMemberNet: {
    //查询部门成员列表信息
    url: '/scooper-core-rest/data/contacts/orgMemberManage/listOrgMember',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      deptId: '',
      //	F	所属部门ID

      /**
       * 可以模糊匹配：
      1.成员名字 2.成员号码  3.号码二~五
      4.手机号码 5.传真号码
      */
      keyword: '',
      //	F	关键字
      ids: '' //	F	通过ids串查询列表（','分割）

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //	T	
        deptId: '',
        //	T	部门ID
        memCode: '',
        //	T	成员编号, 供第三方关联使用
        memName: '',
        //	T	成员姓名
        sex: '',
        //	T	性别: 1-男; 2-女
        firstLetter: '',
        //	T	姓名拼音首字母
        memTel: '',
        //	T	成员号码
        memType: '',
        //	T	成员类型:0-一般用户；1-视频话机用户；2-移动终端用户；
        memMobile: '',
        //	T	手机号码
        memTel2: '',
        //	T	号码二
        memTel3: '',
        //	T	号码三
        memTel4: '',
        //	T	号码四
        memTel5: '',
        //	T	号码五
        memFax: '',
        //	T	传真号码
        memEmail: '',
        //	T	电子邮箱
        memPicture: '',
        //	T	图片
        memVideo: '',
        //	T	视频
        memGis: '',
        //	T	GI坐标
        orgCode: '',
        //	T	组织编码
        sortIndex: '',
        //T	排序号
        updateTime: '',
        //	T	更新时间
        deptExt: '',
        //	T	扩展字段
        isActive: '',
        //	T	是否激活
        modifyTime: '',
        //	T	记录修改时间
        memLevel: '',
        //	T	成员等级
        memQq: '',
        //	T	QQ号码
        deptName: '' //	T	部门名称

      }] //部门成员列表, //	T	结果集

    }
  },
  findOrgMemberByTelNet: {
    //按号码搜索成员
    url: '/scooper-core-rest/data/contacts/orgMemberManage/findOrgMemberByTel',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      tel: '',
      //	T	号码
      all: '',
      //	F	true:查找所有可能的号码  fasle-主号码
      type: '' //	F	如果all = false, 则必填type参数 0: 号码二(默认) 1: 手机号码 2: 传真号码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //	T	
        deptId: '',
        //	T	部门ID
        memCode: '',
        //	T	成员编号, 供第三方关联使用
        memName: '',
        //	T	成员姓名
        sex: '',
        //	T	性别: 1-男; 2-女
        firstLetter: '',
        //	T	姓名拼音首字母
        memTel: '',
        //	T	成员号码
        memType: '',
        //	T	成员类型:0-一般用户；1-视频话机用户；2-移动终端用户；
        memMobile: '',
        //	T	手机号码
        memTel2: '',
        //	T	号码二
        memTel3: '',
        //	T	号码三
        memTel4: '',
        //	T	号码四
        memTel5: '',
        //	T	号码五
        memFax: '',
        //	T	传真号码
        memEmail: '',
        //	T	电子邮箱
        memPicture: '',
        //	T	图片
        memVideo: '',
        //	T	视频
        memGis: '',
        //	T	GI坐标
        orgCode: '',
        //	T	组织编码
        sortIndex: '',
        //T	排序号
        updateTime: '',
        //	T	更新时间
        deptExt: '',
        //	T	扩展字段
        isActive: '',
        //	T	是否激活
        modifyTime: '',
        //	T	记录修改时间
        memLevel: '',
        //	T	成员等级
        memQq: '',
        //	T	QQ号码
        deptName: '' //	T	部门名称

      }] //部门成员列表, //	T	结果集

    }
  },
  findOrgMemberPathNet: {
    //查询某部门成员在树形结构中的路径

    /**
     * 给定ID获取从公司到该部门成员经过的所有单位/部门/成员的id
     */
    url: '/scooper-core-rest/data/contacts/orgMemberManage/findOrgMemberPath',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '' //	T	部门成员ID

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: '' //ids串(","分隔)

    }
  },
  findAccountByOrgMemberIdNet: {
    //根据部门成员ID获取关联账号

    /**
     * 账号生成时可以关联一个部门成员，该接口提供部门成员反向获取账号信息
     */
    url: '/scooper-core-rest/data/contacts/orgMemberManage/findAccountByOrgMemberId',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      orgMemberId: '' //	T	部门成员ID

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        accId: '',
        //	T	帐号ID
        memId: '',
        //	T	部门成员ID
        memName: '' //	T	部门成员名

      }
    }
  },
  changeOrgMemberSortIndexNet: {
    //修改部门成员排序
    url: '/scooper-core-rest/data/contacts/orgMemberManage/changeOrgMemberSortIndex',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '',
      //	int	T	id
      sortIndex: '',
      //	int	T	新排序号
      oldSortIndex: '' //	int	F	旧排序号

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  listOrgMemberByIdsNet: {
    //查询成员ids的成员列表信息
    url: '/scooper-core-rest/data/contacts/orgMemberManage/listOrgMemberByIds',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      ids: '' //	T	通过ids串查询列表（','分割）(最多100个id)

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //	T	
        deptId: '',
        //	T	部门ID
        memCode: '',
        //	T	成员编号, 供第三方关联使用
        memName: '',
        //	T	成员姓名
        sex: '',
        //	T	性别: 1-男; 2-女
        firstLetter: '',
        //	T	姓名拼音首字母
        memTel: '',
        //	T	成员号码
        memType: '',
        //	T	成员类型:0-一般用户；1-视频话机用户；2-移动终端用户；
        memMobile: '',
        //	T	手机号码
        memTel2: '',
        //	T	号码二
        memTel3: '',
        //	T	号码三
        memTel4: '',
        //	T	号码四
        memTel5: '',
        //	T	号码五
        memFax: '',
        //	T	传真号码
        memEmail: '',
        //	T	电子邮箱
        memPicture: '',
        //	T	图片
        memVideo: '',
        //	T	视频
        memGis: '',
        //	T	GI坐标
        orgCode: '',
        //	T	组织编码
        sortIndex: '',
        //T	排序号
        updateTime: '',
        //	T	更新时间
        deptExt: '',
        //	T	扩展字段
        isActive: '',
        //	T	是否激活
        modifyTime: '',
        //	T	记录修改时间
        memLevel: '',
        //	T	成员等级
        memQq: '',
        //	T	QQ号码
        deptName: '' //	T	部门名称

      }] //部门成员列表, //	T	结果集

    }
  },

  /**
   * MQTT订阅
   */
  orgMemberAddMQNet: function () {
    //新增部门成员信息通知
    return {
      topic: '/scooper_core/dataChange/orgMember',
      responseParam: {
        id: '',
        type: 'add',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: {//通知的具体消息
        }
      }
    };
  },
  orgMemberUpdateMQNet: function () {
    //更新部门成员信息通知
    return {
      topic: '/scooper_core/dataChange/orgMember',
      responseParam: {
        id: '',
        type: 'update',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: {//通知的具体消息
        }
      }
    };
  },
  orgMemberDeleteMQNet: function () {
    //删除部门成员信息通知
    return {
      topic: '/scooper_core/dataChange/orgMember',
      responseParam: {
        id: '',
        type: 'delete',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: '' //删除的id, 多个以“,”分隔

      }
    };
  },

  /**
   * HTTP推送
   */
  orgMemberAddHttpNet: function () {
    return {
      //新增部门成员信息通知HTTP推送通知
      url: '/data/dataChange/orgMember/add',
      method: 'POST',
      requestParam: {
        id: '' //新增成员ID

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  },
  orgMemberUpdateHttpNet: function () {
    return {
      //更新部门成员信息通知HTTP推送通知
      url: '/data/dataChange/orgMember/update',
      method: 'POST',
      requestParam: {
        id: '' //更新部门成员ID

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  },
  orgMemberDeleteHttpNet: function () {
    return {
      //删除部门成员信息通知HTTP推送通知
      url: '/data/dataChange/orgMember/delete',
      method: 'POST',
      requestParam: {
        id: '' //id 多个以“，”分隔

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  }
  /*** end  */

};
export default dept_ry;